import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IReportStrings extends LocalizedStringsMethods {
    isReportsText: string;
    lsHomeTxt: string;
    isManageTxt: string;
    lsPrintTxt: string;
    lsCSVDisplayedProfile: string;
    lsCSVAllProfile: string;
}

let strings: IReportStrings;
export default strings = new LocalizedStrings({
    en: {     
        isReportsText: 'Tests',
        isAdditionalInformationText: 'Failed Tests and Baselines',
        lsHomeTxt: 'Home',
        isManageTxt: 'Reports',
        lsPrintTxt: 'Print',
        lsCSVDisplayedProfile: 'CSV (as displayed)',
        lsCSVAllProfile: 'CSV (all profile info)'
    },
    es: {
        isReportsText: 'Pruebas',
        isAdditionalInformationText: 'Pruebas fallidas y líneas base',
        lsHomeTxt: 'Inicio',
        isManageTxt: 'Informes',
        lsPrintTxt: 'Impresión',
        lsCSVDisplayedProfile: 'CSV (como se muestra)',
        lsCSVAllProfile: 'CSV (toda la información del perfil)'
    }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/reports/string.reports.tsx